import { useState } from 'react'
import { Plus } from 'lucide-react'
import { usePersonalBoard } from '../hooks'
import { KanbanBoard } from '../components/KanbanBoard'
import { CreateTaskDialog } from '../components/CreateTaskDialog'

/**
 * Strona `/tasks` - kanban personalnego boardu zalogowanego usera.
 * Header z przyciskiem "+ Nowe zadanie" otwiera CreateTaskDialog (task tworzony
 * bez kontekstu - "luźny" task, np. "Podlać kwiatki"). Tasks z kontekstem
 * (umowa) tworzy się z poziomu umowy.
 */
export function TasksPage() {
  const board = usePersonalBoard()
  const [createOpen, setCreateOpen] = useState(false)

  return (
    <div className="flex flex-col h-full w-full">
      <div className="flex items-center justify-between border-b border-slate-200 px-4 py-3">
        <div>
          <h1 className="text-lg font-semibold">Zadania</h1>
          <p className="text-xs text-slate-500">Twój osobisty board</p>
        </div>
        <button
          type="button"
          onClick={() => setCreateOpen(true)}
          className="inline-flex items-center gap-1.5 rounded bg-sky-600 px-3 py-1.5 text-sm font-medium text-white hover:bg-sky-700"
        >
          <Plus className="h-4 w-4" />
          Nowe zadanie
        </button>
      </div>
      <div className="flex-1 min-h-0">
        {board.isLoading && (
          <div className="p-4 text-sm text-slate-500">Ładowanie boardu…</div>
        )}
        {board.isError && (
          <div className="p-4 text-sm text-red-600">Nie udało się załadować boardu.</div>
        )}
        {board.data && <KanbanBoard board={board.data} />}
      </div>
      {createOpen && <CreateTaskDialog onClose={() => setCreateOpen(false)} />}
    </div>
  )
}
